import {
  FETCH_SINGLE_PRODUCT,
  CHANGE_CURRENCY,
  RECEIVE_PRODUCTS,
} from "../constants/ActionTypes";

const initialState = {
  symbol: "POINTS",
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CURRENCY:
      return { ...state, symbol: "POINTS" };
    default:
      return state;
  }
};
export default productReducer;
